export default __webpack_public_path__ + "static/media/arrowBlueUp.b0e558a0.svg";